
<template>
    <div style="margin-left:50px;">
  
      <el-form style="display: flex;flex-wrap: wrap;">
  
          <el-form-item label="审批人:" style="display: flex;width: 33%;">
              <el-select
                  placeholder="请选择审批人"
                  v-model="student"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="创建人:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择创建人"
                  v-model="student_s"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                  v-for="item in getStudentsArr_s"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="方案名称:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择方案名称"
                  v-model="coursecancellationStatusInput"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
  
          <el-form-item label="日期:" style="display: flex;width: 33%;"  label-width="75px">
              <el-date-picker
              style="width: 104%;margin-left: -139px;"
              v-model="dateTimeList"
              type="daterange"
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              clearable>
              </el-date-picker>
          </el-form-item>
  
          <el-form-item label="审核状态:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择审核状态"
                  v-model="coursecancellationStatusInput_s"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          <el-form-item label="参训人完成状态:" style="display: flex;width: 33%;" >
              <el-select
                  placeholder="请选择参训人完成状态"
                  v-model="coursecancellationStatusInput_ss"
                  style="width: 100%"
                  clearable
                  filterable >
                  <el-option
                  v-for="item in coursecancellationStatus"
                  :key="item.id"
                  :value="item.id"
                  :label="item.realname"
                  >
                  </el-option>
              </el-select>
          </el-form-item>
  
          
          <div style="display: flex;justify-content: end;width: 100%;margin-top: 10px;margin-bottom: 30px;">
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="AddexportBtns">添加问卷</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-search" @click="searchBtns">搜索</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-close" @click="clearBtns">清空</el-button>
               <el-button style="height: 30px;" type="primary" size="small" class="btns" icon="el-icon-download" @click="exportBtns">导出</el-button>
          </div>
  
      </el-form>
  
  
      <el-table  :header-cell-style="{ background: '#fafafa', 'text-align':'center' }"  :cell-style="{'text-align':'center'}" :data="dataList" border height="400">
          <!-- <el-table-column prop="courseDate" label="日期">
            <template slot-scope="scope">
               <span>{{scope.row.courseDate.substring(0,10)}}</span>
            </template>
          </el-table-column> -->
          <el-table-column prop="courseStartTime" label="方案名称"></el-table-column>
          <el-table-column prop="courseEndTime" label="提交人"></el-table-column>
          <el-table-column prop="subjectName" label="审批人"></el-table-column>
          <el-table-column prop="subjectName" label="参训人完成进度"></el-table-column>
          <el-table-column prop="subjectName" label="审批状态"></el-table-column>
          <el-table-column prop="subjectName" label="通过/驳回原因"></el-table-column>
          <el-table-column label="操作">
              <template slot-scope="scope">
                <div style="display: flex;justify-content: space-around;">
                  <!-- <el-button type="text" style="color:#00aaff;" @click="handleClickView('编辑', scope.row)">编辑</el-button> -->
                  <el-button type="text" style="color:#00aaff;" @click="handleClickView('详情', scope.row)">详情</el-button>
                </div>
              </template>
          </el-table-column>
        </el-table>
  
  
  
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
        :current-page="requestParameters.pageNum" :page-size="requestParameters.pageSize"
        layout="prev, pager, next,sizes, jumper" :total="requestParameters.total">
      </el-pagination>
  
  
  
      <el-dialog :title="ShowDlongTitle" :visible.sync="ShowDlong" :before-close="commitCler">
          
          <el-form ref="form" :model="form" label-width="80px">
  
              <el-form-item label="方案内容:" style="text-align: start;">
                  <div style="text-align: start;">{{form.student}}</div>
              </el-form-item>
              <el-divider></el-divider>
  
              <el-form-item label="提交人:" style="text-align: start;">
                 <div style="text-align: start;">{{form.student_s}}</div>
              </el-form-item>
              <el-divider></el-divider>
  
             <el-form-item label="相关资料:" style="text-align: start;">
              <div style="text-align: start;height: 47px; overflow-x: auto;">
                  <a style="margin-right: 10px;" v-for="(itme,index) in form.coursecancellationStatusInput" :key="index" :href="itme.url">{{ itme.name }}</a>
              </div>
             </el-form-item>
             <el-divider></el-divider>
  
             <el-form-item label="提交日期:" style="text-align: start;">
                 <div style="text-align: start;">{{form.dateTimeList}}</div>
             </el-form-item>
             <el-divider></el-divider>
  
  
          </el-form>
  
  
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="commitCler">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd('No')">驳回</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="commitAdd('Yes')">通过</el-button>
          </div>
  
      </el-dialog>
      
  
  
      <el-dialog title="添加培训任务" style="padding: 0px 10px;" :visible.sync="AddShowDlong" :before-close="AddcommitCler">
          
          <el-form ref="form" :model="form" label-width="100px">
  
              <el-form-item label="培训名称:">
                  <el-input placeholder="请选择培训名称" v-model="Addform.TrainName" style="width: 100%" clearable> 
                  </el-input>
              </el-form-item>
  
              <el-form-item label="任务创建人:">
                <el-select
                  placeholder="请选任务创建人"
                  v-model="Addform.CreatorName"
                  style="width: 100%"
                  clearable
                  filterable>
                  <el-option
                      v-for="item in getStudentsArr_s"
                      :key="item.id"
                      :value="item.id"
                      :label="item.realname">
                  </el-option>
              </el-select>
              </el-form-item>
  
             <el-form-item label="参加培训人:">
              <el-select
                  placeholder="请选择参加培训人"
                  v-model="Addform.TrainerName"
                  style="width: 100%"
                  clearable
                  filterable>
                   <el-option
                       v-for="item in coursecancellationStatus"
                       :key="item.id"
                       :value="item.id"
                       :label="item.realname" >
                   </el-option>
              </el-select>
             </el-form-item>
  
             <el-form-item label="培训内容:">
                  <div style="width: 100%;height: 250px;overflow-x: auto;display: flex;">
                      <el-radio  @click="clickitem(item.id)" border v-model="Addform.TrainingContent"
                           style="width: 130px; height: 100%;" v-for="(item, index) in planArr" :key="index" :label='item.id'>
                          <h3 style="margin-top: 0px;">{{ item.planName }}</h3>
                          <div style="text-align: left;"  v-for="(item1, index1) in item.planList" :key="index1">
                              <p>课节数:{{ item1.classNum }}</p>
                              <p style="margin-bottom: 20px;">课时单价:{{ item1.classPrice }}</p>
                          </div>
                      </el-radio>
                  </div>
             </el-form-item>
  
             <el-form-item label="资料上传:">
                  <el-upload
                      class="upload-demo"
                      drag
                      action="#"
                      :on-remove="handleRemove"
                      :beforeUpload="beforeUpload"
                      :http-request="handleUpload"
                      :on-error="handleError"
                      :auto-upload="true"
                      show-file-list
                      :file-list="fileDataList"
                      multiple>
                      <i class="el-icon-upload"></i>
                      <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                  </el-upload>
             </el-form-item>   
  
             <el-form-item label="审批人:">
                  <el-select
                      placeholder="请选择审批人"
                      v-model="Addform.ApprovedName"
                      style="width: 100%"
                      clearable
                      filterable >
                      <el-option
                          v-for="item in coursecancellationStatus"
                          :key="item.id"
                          :value="item.id"
                          :label="item.realname" >
                      </el-option>
                  </el-select>
             </el-form-item>
  
  
          </el-form>
  
  
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="AddcommitCler">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-plus" @click="AddcommitSub">保存</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddcommitAdd">提交</el-button>
          </div>
  
      </el-dialog>
  
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" :visible.sync="ShowapprovalOpinions" :before-close="approvalOpinionsCler">
          <el-input :autosize="{  minRows: 6, maxRows: 6 }"  type="textarea"  placeholder="请输入驳回内容"  v-model="approvalOpinionstextarea" maxlength="200" show-word-limit></el-input>
      
          <div slot="footer" class="dialog-footer">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions">确定</el-button>
          </div>
  
      </el-dialog>
  
  
      <el-dialog title="审批意见" style="padding: 0px 10px;" width="30%" :visible.sync="ShowapprovalOpinions_Yes" :before-close="approvalOpinionsCler_Yes">
          
          <div style="">是否提交审批意见?</div>
  
          <div slot="footer" class="dialog-footer" style="text-align: center;">
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-error" @click="approvalOpinionsCler_Yes">取消</el-button>
            <el-button style="height: 30px;"  size="small" class="btns" icon="el-icon-success" type="primary" @click="AddapprovalOpinions_Yes">确定</el-button>
          </div>
  
      </el-dialog>
  
  
  
  
  
  
  </div>
</template>
  
<script>
  import axios from "axios";
  import apiBaseUrl from "../../config/api";
  import Vue from 'vue';
  import { ref, reactive, onMounted, defineComponent, toRefs, nextTick, onUpdated, watchEffect } from '@vue/composition-api'
  var $Vue = Vue.prototype
  import {  getStudentsType } from "@/api/fiveClassApi"
  import { put, signatureUrl, getFileNameUUID } from "../utils/oss";
  import loadingUtils from "../utils/loading";
  import { isReturn } from "../utils/retnue";
  
  export default defineComponent({
  
      setup(props, { attrs, slots, emit, expose }){
  
          let approvalOpinionstextarea = ref('')
          let ShowapprovalOpinions = ref(false)
          let getStudentsArr = ref([])
          let getStudentsArr_s = ref([])
          let coursecancellationStatus = ref([])
          let student = ref('')
          let student_s = ref('')
          let coursecancellationStatusInput = ref('')
          let coursecancellationStatusInput_s = ref('')
          let coursecancellationStatusInput_ss = ref('')
          let dateTimeList = ref([])
          let dataList = ref([])
          let requestParameters = reactive({pageSize:10,total:0,pageNum:0})
          let ShowDlong = ref(false)
          let ShowDlongDisabled = ref(false)
          let ShowDlongTitle = ref('编辑')
          let form = reactive({ student:'', student_s: '', coursecancellationStatusInput:[], dateTimeList: '' })
          let AddShowDlong = ref(false)
          let Addform = reactive({ TrainName:'', CreatorName:'', TrainerName: '', TrainingContent:'', DataUpload: '', ApprovedName: '' })
          let planArr = ref([])
          let fileDataList = ref([])
          let ShowapprovalOpinions_Yes = ref(false)
  
  
          onMounted(()=>{
              handleAllApi()
          })
  
          watchEffect(() => {
              console.log(`Count is now 让子弹飞一会`);
          })
  
  
          const handleAllApi = () =>{
              getStudentsArr.value = [{ id: 1, realname : '李四' },{ id: 2, realname : '张三' },{ id: 3, realname : '王五' }]
              getStudentsArr_s.value = [{ id: 1, realname : '颇多野' },{ id: 2, realname : '梅川合' },{ id: 3, realname : '拖一大' }]
              coursecancellationStatus.value = [{ id: 1, realname : '唱' },{ id: 2, realname : '跳' },{ id: 3, realname : 'rap' }]
              dataList.value = [{ courseDate: '2024-01-14', courseStartTime: '张三', courseEndTime: '颇多野', subjectName: [{url:'https:baidu.com',name:'虚拟图片'},{url:'https:baidu.com',name:'虚拟图片2'}]  }]
  
              axios.post(`${apiBaseUrl}/contract/getList`, requestParameters,{
                  headers:{
                      'authorization': sessionStorage.getItem('tokenInfo')
                  },
              }).then(res => {
                  isReturn(res.code)
                  planArr.value = res.data.data.records
              }).catch(error => {
                  console.error(error)
              })
          }
  
          const handleMessage = (message,type) =>{
               $Vue.$message({ message, type, duration: 500 });
          }
  
          const approvalOpinionsCler = ()=>{
              approvalOpinionstextarea.value = ''
              ShowapprovalOpinions.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const exportBtns = () =>{
  
          }
          const searchBtns = () =>{
  
          }
          const clearBtns = () =>{
              student.value = ""
              student_s.value = ""
              coursecancellationStatusInput.value = ""
              coursecancellationStatusInput_s.value = ""
              coursecancellationStatusInput_ss.value = ""
              dateTimeList.value = []
          }
          const addBtns = () =>{
              AddShowDlong.value = true
          }
  
          const handleSizeChange = (size) =>{
              requestParameters.pageSize = size
          }
          const handleCurrentChange = (page) =>{
              requestParameters.pageNum = page
          }
  
          const handleClickView = (boom, edible)=>{
              let { courseDate, courseEndTime, courseStartTime, subjectName } = edible
              form.student = courseStartTime
              form.student_s = courseEndTime
              form.coursecancellationStatusInput = subjectName
              form.dateTimeList = courseDate
              ShowDlong.value = true
              sessionStorage.setItem('detailsInfo',JSON.stringify(form))
              if(boom === '编辑'){
                  ShowDlongDisabled.value = false
                  ShowDlongTitle.value = '编辑'
              }
              if(boom === '详情'){
                  ShowDlongDisabled.value = true
                  ShowDlongTitle.value = '方案名称详情'
              }
          }
  
  
          const commitCler = () =>{
              ShowDlong.value = false
              sessionStorage.setItem('detailsInfo',JSON.stringify(null))
              handleClrAll()
          }
  
          const commitAdd = (boomm) =>{
              if(boomm === 'No'){
                  ShowapprovalOpinions.value = true
              }
              if(boomm === 'Yes'){
                  ShowapprovalOpinions_Yes.value = true
              }
              ShowDlong.value = false
              handleClrAll()
          }
  
          const handleClrAll = () =>{
              form.student = ""
              form.student_s = ""
              form.coursecancellationStatusInput = []
              form.dateTimeList = ""
          }
  
          const AddcommitCler = () =>{
              AddShowDlong.value = false
              handleClerAllDing()
          }
  
          const AddcommitAdd = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
          
          const AddexportBtns = () => {

          }

          const AddcommitSub = () =>{
              console.log(Addform, 'Addform')
              console.log(fileDataList.value, 'fileDataList')
  
  
              AddShowDlong.value = false
              // setTimeout(()=>{
              //     handleClerAllDing()
              // },2000)
          }
  
          const handleClerAllDing = () =>{
              fileDataList.value = []
              Addform.TrainName = ""
              Addform.CreatorName = ""
              Addform.TrainerName = ""
              Addform.TrainingContent = ""
              Addform.ApprovedName = ""
          }
  
          const clickitem = (itme) =>{
              console.log(itme, 'itme')
          }
  
          const handleRemove = (file, fileList) =>{
              fileDataList.value = fileList
          }
  
          const getFileName = (name) => {
               return name.substring(name.lastIndexOf("."))
          }
  
          const beforeUpload = (file, fileList) =>{
              loadingUtils.startLoading()
              const fileExtensions =
                  getFileName(file.name) === ".bmp" ||
                  getFileName(file.name) === ".tif" ||
                  getFileName(file.name) === ".gif" ||
                  getFileName(file.name) === ".pcx" ||
                  getFileName(file.name) === ".svg" ||
                  getFileName(file.name) === ".psd" ||
                  getFileName(file.name) === ".webp" ||
                  getFileName(file.name) === ".apng" ||
                  getFileName(file.name) === ".ai" ||
                  getFileName(file.name) === ".avif" ||
                  getFileName(file.name) === ".png" ||
                  getFileName(file.name) === ".pdf"||
                  getFileName(file.name) === ".mp4"||
                  getFileName(file.name) === ".excel"||
                  getFileName(file.name) === ".doc"||
                  getFileName(file.name) === ".ppt"||
                  getFileName(file.name) === ".mp3"||
                  getFileName(file.name) === ".xls"||
                  getFileName(file.name) === ".xlsx"||
                  getFileName(file.name) === ".pptx"||
                  getFileName(file.name) === ".docx"||
                  getFileName(file.name) === ".txt"||
                  getFileName(file.name) === ".jpg";
              const max20M = file.size / 1024 / 1024 < 1000;
  
              if (!fileExtensions) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
              if (!max20M) {
                  handleMessage("上传文件类不合格式!", 'warning')
              }
  
              return fileExtensions && max20M
          }
  
          const handleUpload = (option) =>{
              let obj = option.file.name
              let index = obj.lastIndexOf(".")
              obj = obj.substring(index, obj.length)
              let objName = getFileNameUUID() + getFileName(option.file.name)
              put(`mz_pc/${objName}`, option.file).then((res) => {
                  loadingUtils.endLoading()
                  signatureUrl(`mz_pc/${objName}`).then((res) => {})
              });
          }
  
          const handleError = () =>{
              loadingUtils.endLoading()
          }
  
  
          const AddapprovalOpinions = () =>{
              ShowapprovalOpinions.value = false
              approvalOpinionstextarea.value = ''
              handleMessage('提交了驳回','success')
          }
  
          const approvalOpinionsCler_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              ShowDlong.value = true
              let detailsInfo = JSON.parse(sessionStorage.getItem('detailsInfo'))
              if(detailsInfo){
                 form.student = detailsInfo.student
                 form.student_s = detailsInfo.student_s
                 form.coursecancellationStatusInput = detailsInfo.coursecancellationStatusInput
                 form.dateTimeList = detailsInfo.dateTimeList
              }
          }
  
          const AddapprovalOpinions_Yes = () => {
              ShowapprovalOpinions_Yes.value = false
              handleMessage('提交了通过','success')
          }
  
  
          return {
              handleUpload,
              beforeUpload,
              handleError,
              getFileName,
              handleRemove,
              handleClerAllDing,
              fileDataList,
              clickitem,
              AddcommitCler,
              AddcommitAdd,
              commitCler,
              commitAdd,
              handleMessage,
              getStudentsArr,
              getStudentsArr_s,
              coursecancellationStatus,
              student,
              student_s,
              planArr,
              coursecancellationStatusInput,
              coursecancellationStatusInput_s,
              coursecancellationStatusInput_ss,
              dateTimeList,
              handleAllApi,
              exportBtns,
              searchBtns,
              clearBtns,
              addBtns,
              dataList,
              handleClickView,
              handleSizeChange,
              handleCurrentChange,
              requestParameters,
              ShowDlongTitle,
              ShowDlong,
              form,
              ShowDlongDisabled,
              handleClrAll,
              AddcommitSub,
              AddShowDlong,
              Addform,
              ShowapprovalOpinions,
              approvalOpinionsCler,
              approvalOpinionstextarea,
              AddapprovalOpinions,
              ShowapprovalOpinions_Yes,
              approvalOpinionsCler_Yes,
              AddapprovalOpinions_Yes,
              AddexportBtns,
  
          }
  
      }
  
  })
  
  
</script>
  
<style scoped  lang="less">
  
  .btns{
    background-color: #428BCA;
    border-color: #428BCA;
    color: #fff;
  }
  
  /deep/ .el-upload{
      width: 100% !important;
  }
  /deep/ .el-form-item__label{
      text-align: start;
  }
  
</style>


// WEBPACK FOOTER //
// src/InitializationFile/answerEntrance.vue